import ThermalPrinterBase from "../../services/thermalPrinter/ThermalPrinterBase";
import PrintJobNiceloopV1Builder from "~/class/printer/PrintJobNiceloopV1Builder";
import PrintCustomNiceloopV1Builder from "~/class/printer/PrintCustomNiceloopV1Builder";


export default class ThermalPrintVoidItems extends ThermalPrinterBase {
    // Per-station kitchen void slips — items split across printers by their tags.
    printVoidItems(job : any, options : any){
      const jobVoid =  this.withPayload(job, options)
      console.log("jobVoid=>", jobVoid)
      this.print_data = jobVoid
      return this

    }

    // Cashier (printer 0) copy — EVERY voided item + reason on one slip, via
    // /printcustom, regardless of which kitchen printer each item belongs to.
    printVoidItemsCashier(payload : any){
      this.print_data = new PrintCustomNiceloopV1Builder().makeVoidItemsCashier(payload).build()
      return this
    }

    withPayload(job : any, options : any){
      const payload = {...job, ...options}
      const printJobBuilder =  new PrintJobNiceloopV1Builder(options?.productsStore)

      const jobVoid =  printJobBuilder.makePrintJobVoid(payload).build();
      return jobVoid
    }

    setPayload(payload:any){
      this.print_data = payload
      return this
    }
}
